(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function format(value, decimals) {
      return value.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }

    function countUp(el) {
      if (el.dataset.gdCounted) return;
      el.dataset.gdCounted = '1';
      var target = parseFloat(el.getAttribute('data-gd-count'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (isNaN(target)) return;
      var duration = 1800;
      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = format(target * eased, decimals) + suffix;
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function init(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-gd-about]');
      if (!sections.length) return;

      if (reduce || !('IntersectionObserver' in window)) return;

      sections.forEach(function (section) {
        if (section.dataset.gdAboutReady) return;
        section.dataset.gdAboutReady = '1';
        section.classList.add('gd-ab--anim');

        var counters = section.querySelectorAll('[data-gd-count]');
        counters.forEach(function (el) {
          var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10) || 0;
          el.textContent = format(0, decimals) + (el.getAttribute('data-suffix') || '');
        });

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var el = entry.target;
              io.unobserve(el);
              if (el.hasAttribute('data-gd-count')) countUp(el);
              else el.classList.add('is-live');
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
        );

        counters.forEach(function (el) { io.observe(el); });
        section.querySelectorAll('.gd-ab-rate, .gd-ab-promise, [data-gd-steps]').forEach(function (el) { io.observe(el); });

        /* Safety net: never leave content hidden if the observer does not fire. */
        setTimeout(function () {
          section.querySelectorAll('.gd-ab-rate, .gd-ab-promise, [data-gd-steps]').forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-live');
          });
        }, 2500);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-combo-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
function formatMoney(cents, fmt) {
var value = (cents || 0) / 100;
function withCommas(n, dec) {
var parts = n.toFixed(dec).split('.');
parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
return parts.join('.');
}
var f = fmt || 'Rs. {{amount}}';
return f
.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(value, 0))
.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas(value, 2).replace('.', ','))
.replace(/\{\{\s*amount\s*\}\}/, withCommas(value, 2))
.replace(/<[^>]*>/g, '');
}
function init(root) {
if (!root || root.dataset.gdCbReady) return;
var jsonEl = root.querySelector('[data-gd-cb-json]');
if (!jsonEl) return;
var data;
try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
root.dataset.gdCbReady = '1';
var fmt = data.fmt;
var items = data.items || {};
var byKey = {};
var list = [];
(data.products || []).forEach(function (p) {
if (!p || !p.k) return;
var ks = p.k.split('|').sort();
p.k = ks.join('|');
if (byKey[p.k] && byKey[p.k].p <= p.p) return;
byKey[p.k] = p;
list.push(ks);
});
var sel = [];
var lastMatch = null;
var tiles = Array.prototype.slice.call(root.querySelectorAll('.gd-cb__tile'));
var q = function (s) { return root.querySelector(s); };
var hint = q('[data-gd-cb-hint]');
var hintText = hint ? hint.textContent : '';
var panel = q('[data-gd-cb-panel]');
var empty = q('[data-gd-cb-empty]');
var emptyTitle = q('[data-gd-cb-empty-title]');
var emptyTitleText = emptyTitle ? emptyTitle.textContent : '';
var result = q('[data-gd-cb-result]');
var nomatch = q('[data-gd-cb-nomatch]');
var sugs = q('[data-gd-cb-sugs]');
var idInput = q('[data-gd-cb-id]');
var varWrap = q('[data-gd-cb-varwrap]');
var varSel = q('[data-gd-cb-var]');
var buy = q('[data-gd-cb-buy]');
var atc = root.querySelector('add-to-cart-component');
var atcBtn = root.querySelector('.gd-cb__add');
var bar = q('[data-gd-cb-bar]');
var hearts = q('[data-gd-cb-hearts]');
function keyOf(arr) { return arr.slice().sort().join('|'); }
function contains(big, small) { return small.every(function (k) { return big.indexOf(k) > -1; }); }
function reachable(arr) { return list.some(function (ks) { return contains(ks, arr); }); }
function label(k) { return (items[k] && items[k].l) || k; }
function single(k) { return (items[k] && items[k].p) || 0; }
function show(el, on) { if (el) el.hidden = !on; }
function countTo(el, to) {
if (!el) return;
var from = parseInt(el.dataset.v || '0', 10);
el.dataset.v = String(to);
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches || from === to) {
el.textContent = formatMoney(to, fmt);
return;
}
var start = null;
function step(now) {
if (start === null) start = now;
var t = Math.min(1, (now - start) / 600);
var v = Math.round(from + (to - from) * (1 - Math.pow(1 - t, 3)));
el.textContent = formatMoney(v, fmt);
if (t < 1) requestAnimationFrame(step);
}
requestAnimationFrame(step);
}
function burst() {
if (!hearts || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
var icons = ['💖', '✨', '💗', '⭐', '🎉'];
for (var i = 0; i < 7; i++) {
var h = document.createElement('span');
h.className = 'gd-cb__heart';
h.textContent = icons[i % icons.length];
h.style.left = 10 + Math.random() * 80 + '%';
h.style.animationDelay = i * 0.07 + 's';
hearts.appendChild(h);
setTimeout(function (n) { return function () { n.remove(); }; }(h), 1600);
}
}
function setVariant(id) {
if (idInput) idInput.value = id;
if (buy) buy.setAttribute('href', buy.getAttribute('data-cart-base') + id + ':1');
}
function renderMatch(p) {
show(empty, false); show(nomatch, false); show(result, true);
var img = q('[data-gd-cb-img]');
if (img && p.i) { img.src = p.i; img.alt = p.t; }
var title = q('[data-gd-cb-title]');
if (title) title.textContent = p.t;
countTo(q('[data-gd-cb-now]'), p.p);
var mrp = q('[data-gd-cb-mrp]');
var off = q('[data-gd-cb-off]');
if (p.c > p.p) {
mrp.textContent = formatMoney(p.c, fmt);
off.textContent = Math.floor(((p.c - p.p) * 100) / p.c) + '% off';
} else { mrp.textContent = ''; off.textContent = ''; }
var sep = sel.reduce(function (a, k) { return a + single(k); }, 0);
var save = sep - p.p;
var saveRow = q('[data-gd-cb-saverow]');
if (save > 0) {
q('[data-gd-cb-sep]').textContent = formatMoney(sep, fmt);
q('[data-gd-cb-save]').textContent = 'You save ' + formatMoney(save, fmt);
show(saveRow, true);
} else { show(saveRow, false); }
var view = q('[data-gd-cb-url]');
if (view) view.setAttribute('href', p.u);
if (atc && p.i) atc.setAttribute('data-product-variant-media', p.i);
var avail = p.v.filter(function (v) { return v[2]; });
varSel.innerHTML = '';
p.v.forEach(function (v) {
var o = document.createElement('option');
o.value = v[0];
o.textContent = v[1] + (v[2] ? '' : ' – Sold out');
o.disabled = !v[2];
varSel.appendChild(o);
});
show(varWrap, p.v.length > 1 && p.v[0][1] !== 'Default Title');
var first = avail[0] || p.v[0];
if (first) { varSel.value = first[0]; setVariant(first[0]); }
var can = avail.length > 0;
if (atcBtn) atcBtn.disabled = !can;
if (buy) buy.classList.toggle('is-off', !can);
if (bar) {
bar.hidden = false;
bar.classList.add('is-on');
q('[data-gd-cb-bar-now]').textContent = formatMoney(p.p, fmt);
q('[data-gd-cb-bar-save]').textContent = save > 0 ? 'You save ' + formatMoney(save, fmt) : p.t;
}
if (lastMatch !== p.k) {
if (panel) { panel.classList.remove('is-bump'); void panel.offsetWidth; panel.classList.add('is-bump'); }
burst();
}
lastMatch = p.k;
}
function hideBar() { if (bar) { bar.classList.remove('is-on'); bar.hidden = true; } }
function renderNoMatch() {
show(empty, false); show(result, false); show(nomatch, true); hideBar();
lastMatch = null;
sugs.innerHTML = '';
var out = [];
Object.keys(items).forEach(function (k) {
if (sel.indexOf(k) > -1) return;
var p = byKey[keyOf(sel.concat([k]))];
if (p) out.push({ k: k, add: true, p: p });
});
sel.forEach(function (k) {
if (sel.length - 1 < 2) return;
var p = byKey[keyOf(sel.filter(function (x) { return x !== k; }))];
if (p) out.push({ k: k, add: false, p: p });
});
out.slice(0, 4).forEach(function (o) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'gd-cb__sug';
b.innerHTML = '<span></span><b></b>';
b.firstChild.textContent = (o.add ? '+ Add ' : '− Remove ') + label(o.k);
b.lastChild.textContent = formatMoney(o.p.p, fmt);
b.addEventListener('click', function () { toggle(o.k); });
sugs.appendChild(b);
});
}
function render() {
tiles.forEach(function (t) {
var k = t.getAttribute('data-key');
var on = sel.indexOf(k) > -1;
t.setAttribute('aria-pressed', on ? 'true' : 'false');
var off = !on && sel.length > 0 && !reachable(sel.concat([k]));
t.classList.toggle('is-off', off);
t.setAttribute('aria-disabled', off ? 'true' : 'false');
});
if (hint) { hint.textContent = hintText; hint.classList.remove('is-warn'); }
if (sel.length < 2) {
show(result, false); show(nomatch, false); show(empty, true); hideBar();
lastMatch = null;
if (emptyTitle) emptyTitle.textContent = sel.length === 1 ? 'Nice pick! Add one more 👉' : emptyTitleText;
return;
}
var p = byKey[keyOf(sel)];
if (p) renderMatch(p); else renderNoMatch();
}
function toggle(k) {
var i = sel.indexOf(k);
var tile = root.querySelector('.gd-cb__tile[data-key="' + k + '"]');
if (i > -1) { sel.splice(i, 1); }
else {
if (sel.length > 0 && !reachable(sel.concat([k]))) {
if (tile) { tile.classList.remove('is-shake'); void tile.offsetWidth; tile.classList.add('is-shake'); }
if (hint) { hint.textContent = label(k) + ' is not in a combo with your current picks.'; hint.classList.add('is-warn'); }
return;
}
sel.push(k);
if (tile) { tile.classList.remove('is-picked'); void tile.offsetWidth; tile.classList.add('is-picked'); }
}
render();
}
tiles.forEach(function (t) {
t.addEventListener('click', function () { toggle(t.getAttribute('data-key')); });
});
if (varSel) varSel.addEventListener('change', function () { setVariant(varSel.value); });
if (buy) buy.addEventListener('click', function (e) {
if (!idInput || !idInput.value || buy.classList.contains('is-off')) { e.preventDefault(); }
});
render();
}
function boot(scope) {
(scope || document).querySelectorAll('[data-gd-cb]').forEach(init);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
else boot();
document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-festive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function init(root) {
      if (!root || root.dataset.gdFestReady) return;
      root.dataset.gdFestReady = '1';
      var target = new Date((root.getAttribute('data-date') || '') + 'T00:00:00+05:30');
      var count = root.querySelector('[data-gd-count]');
      var done = root.querySelector('[data-gd-count-done]');
      if (!count) return;
      if (isNaN(target.getTime())) {
        count.hidden = true;
        return;
      }
      var units = {};
      ['d', 'h', 'm', 's'].forEach(function (u) {
        units[u] = count.querySelector('[data-u="' + u + '"]');
      });
      var timer = 0;
      function tick() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) {
          count.hidden = true;
          if (done) done.hidden = false;
          clearInterval(timer);
          return;
        }
        var sec = Math.floor(diff / 1000);
        units.d.textContent = Math.floor(sec / 86400);
        units.h.textContent = pad(Math.floor((sec % 86400) / 3600));
        units.m.textContent = pad(Math.floor((sec % 3600) / 60));
        units.s.textContent = pad(sec % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    }
    function boot(scope) {
      (scope || document).querySelectorAll('[data-gd-fest]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-gift-message"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.gdGmReady) return;
      root.dataset.gdGmReady = '1';
      var data = {};
      try {
        data = JSON.parse(root.querySelector('[data-gd-gm-json]').textContent);
      } catch (e) {}
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var form = root.querySelector('[data-gd-gm-form]');
      var occ = root.querySelector('[data-gd-gm-occ]');
      var to = root.querySelector('[data-gd-gm-to]');
      var from = root.querySelector('[data-gd-gm-from]');
      var msg = root.querySelector('[data-gd-gm-msg]');
      var count = root.querySelector('[data-gd-gm-count]');
      var status = root.querySelector('[data-gd-gm-status]');
      var save = root.querySelector('[data-gd-gm-save]');
      var remove = root.querySelector('[data-gd-gm-remove]');
      var suggest = root.querySelector('[data-gd-gm-suggest]');
      var card = root.querySelector('[data-gd-gm-card]');
      var pOcc = root.querySelector('[data-gd-gm-p-occ]');
      var pTo = root.querySelector('[data-gd-gm-p-to]');
      var pMsg = root.querySelector('[data-gd-gm-p-msg]');
      var pFrom = root.querySelector('[data-gd-gm-p-from]');
      var fx = root.querySelector('[data-gd-gm-fx]');
      var typingTimer = 0;
      var ideaIndex = {};

      function setStatus(text, isError) {
        status.textContent = text || '';
        status.classList.toggle('is-error', !!isError);
      }
      function preview() {
        pOcc.textContent = occ.value;
        pTo.textContent = to.value.trim() || 'little one';
        pFrom.textContent = from.value.trim() || 'You';
        var m = msg.value.trim();
        pMsg.textContent = m || pMsg.getAttribute('data-empty');
        pMsg.classList.toggle('is-placeholder', !m);
        count.textContent = msg.value.length + '/200';
      }
      function typing() {
        card.classList.add('is-typing');
        card.classList.remove('is-sealed');
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
          card.classList.remove('is-typing');
        }, 600);
        preview();
      }
      [to, from, msg].forEach(function (el) {
        el.addEventListener('input', typing);
      });
      occ.addEventListener('change', typing);

      suggest.addEventListener('click', function () {
        var list = (data.ideas && (data.ideas[occ.value] || data.ideas['Just because'])) || [];
        if (!list.length) return;
        var i = ideaIndex[occ.value] || 0;
        msg.value = list[i % list.length];
        ideaIndex[occ.value] = i + 1;
        typing();
        msg.focus();
      });

      document.addEventListener('gd:occasion', function (e) {
        var name = e.detail && e.detail.occasion;
        if (!name) return;
        for (var i = 0; i < occ.options.length; i++) {
          if (occ.options[i].value === name) {
            occ.value = name;
            break;
          }
        }
        typing();
        if (!msg.value.trim()) suggest.click();
      });

      function burst() {
        if (reduce || !fx) return;
        var icons = ['💖', '🎉', '✨', '💌', '⭐'];
        for (var i = 0; i < 12; i++) {
          var s = document.createElement('i');
          s.textContent = icons[i % icons.length];
          var ang = ((i / 12) * 360 * Math.PI) / 180;
          var dist = 90 + Math.random() * 70;
          s.style.setProperty('--x', (Math.cos(ang) * dist).toFixed(0) + 'px');
          s.style.setProperty('--y', (Math.sin(ang) * dist).toFixed(0) + 'px');
          s.style.setProperty('--r', (Math.random() * 120 - 60).toFixed(0) + 'deg');
          fx.appendChild(s);
          setTimeout(
            (function (n) {
              return function () {
                n.remove();
              };
            })(s),
            1400
          );
        }
      }
      function send(attrs) {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(base + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        }).then(function (res) {
          if (!res.ok) throw new Error('save failed');
          return res.json();
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var m = msg.value.trim();
        if (m.length < 2) {
          setStatus(data.empty, true);
          msg.focus();
          return;
        }
        save.disabled = true;
        save.classList.add('is-loading');
        send({
          'Gift message': m,
          'Gift for': to.value.trim(),
          'Gift from': from.value.trim(),
          'Gift occasion': occ.value,
        })
          .then(function () {
            setStatus('✅ ' + data.saved);
            remove.hidden = false;
            card.classList.remove('is-stamp');
            void card.offsetWidth;
            card.classList.add('is-sealed', 'is-stamp');
            burst();
          })
          .catch(function () {
            setStatus(data.error, true);
          })
          .then(function () {
            save.disabled = false;
            save.classList.remove('is-loading');
          });
      });

      remove.addEventListener('click', function () {
        remove.disabled = true;
        send({ 'Gift message': '', 'Gift for': '', 'Gift from': '', 'Gift occasion': '' })
          .then(function () {
            msg.value = '';
            to.value = '';
            from.value = '';
            remove.hidden = true;
            card.classList.remove('is-sealed', 'is-stamp');
            preview();
            setStatus(data.removed);
          })
          .catch(function () {
            setStatus(data.error, true);
          })
          .then(function () {
            remove.disabled = false;
          });
      });

      preview();
    }
    function boot(scope) {
      (scope || document).querySelectorAll('[data-gd-gm]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-gifts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gdGiftChips) return;
    window.__gdGiftChips = true;
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-gd-occasion]');
      if (!chip) return;
      var name = chip.getAttribute('data-gd-occasion');
      document.dispatchEvent(new CustomEvent('gd:occasion', { detail: { occasion: name } }));
      var target = document.getElementById('gift-message');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
